<iframe 
      [src]="safeErpUrl"
      style="width: 100%; height: 100vh; border: none;"
      loading="lazy"
      referrerpolicy="no-referrer"
      sandbox="allow-scripts allow-same-origin allow-forms"
      >
</iframe>
